import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import Banner from './Banner';

import {
	makeStyles
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	restoreBanner: {
		margin: theme.spacing(1.5),
		marginTop: theme.spacing(3)
	},

	hide: {
		marginBottom: 0
	}
}));

function RestoreBanner(props) {
	const bannerRef = useRef();

	let classes = styles(),
		{flagged, show, handleRestore, onEntered, onExited} = props;

	return (
		<Banner
			show={show}
			bannerRef={bannerRef}
			onEntered={onEntered}
			onExited={onExited}
			icon={{icon: ["fas", "trash-alt"]}}
			content="This signal was previously removed."
			className={`${classes.restoreBanner} ${!show ? classes.hide : ""}`}
			actions={[{
				handler: () => handleRestore(),
				text: flagged ? "Restore" : "Restore & Save", color: "primary"
			}]} />
	);
}

RestoreBanner.propTypes = {
	show: PropTypes.bool,
	flagged: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
	handleRestore: PropTypes.func,
	onEntered: PropTypes.func,
	onExited: PropTypes.func
};

export default RestoreBanner;